import React, { useState } from 'react'

import { useNavigate } from 'react-router-dom';


import TitleChnage from "../Hook/TitleChnage";

import imageOne from "../resource/community/1.png";
import imageOtwo from "../resource/community/2.png";
import imageThree from "../resource/community/3.png";
import imageFour from "../resource/community/5.png";
import imageFive from "../resource/community/7.png";
import imageSix from "../resource/community/6.png";
import imageSeven from "../resource/community/8.png"
import imageNine from "../resource/community/4.png";

const Community = () => {

  TitleChnage("Community Service")

  const navigate = useNavigate();

  const [isTextVisible, setIsTextVisible] = useState(false);

  const handleToggle = () => {
    setIsTextVisible((prev) => !prev);
  }

  const handleClick = (event) => {

    const pathMap = {
      paritta: "/paritta",
      dhammasermons: "/dhammasermons",
      danaathome: "/danaathome",
      funeralrituals: '/funeralrituals'
    }

    const path = event.currentTarget.id;
    const targetPath = pathMap[path]

    if (targetPath) {
      navigate(targetPath)
    }
  }

  return (
    <div className="page commiunity-page">
      <img src={imageOne} alt="" className="left-imge" />
      <img src={imageOtwo} alt="" className="right-imge" />

      <header>
        <div className="home-icon">{/* <img src="#" alt="Home Icon"> */}</div>
        <div className="title">
          <h1>Community Service</h1>
          <img src={imageThree} width={300} />
        </div>
      </header>

      <section className="intro-text">
        <p className="meditate-info text-black">
          Bhaddeka Vihari Monastery and Meditation Centre relies solely on the generosity and support of the community.In appreciation of this kind assistance,the Sangha at the monastery strives to share the essence of the Dhamma at residential community level, <span className='lowertext curser-pointer' onClick={handleToggle}>{isTextVisible ? "" : "more"}</span>

        </p>

        {isTextVisible &&
          <div className="hidden-text">
            <p className="dana-info text-black">the Sangha at the monastery strives to share the essence of the Dhamma at residential community level, enhancing the livelihood and spiritual well-being of those who support them. The Dhamma community is blessed by the presence of the Sangha and the protection of the Dhamma through various support events graciously offered by the monastery. These blessings are not only shared during moments of joy or significant milestones but also during sorrowful occasions, such as funerals, ensuring         </p>
            <p className="dana-info text-black">that the community is supported in all circumstances. The primary purpose of the Sangha at Bhaddeka Vihari Monastery is to devote their time to practicing the Dhamma and Vinaya, studying the discourses of the Buddha, and striving to attain Nibbana. In addition to these personal practices, the Sangha conducts regular annual and monthly Dhamma programs and celebrates special Buddhist events and rituals. Given the busy nature of their schedule, it can be challenging to find time for family-level events. However, supporting the Dhamma community is an essential task for the monastery, and as such, a select number of community services are offered.</p>
            <p className="dana-info text-black">Due to the Sangha’s commitments, the number of participants available for these services is strictly limited. To accommodate both the Sangha and the community, a calendar is set for each event, allowing families to select a date in advance. This ensures smooth coordination and meaningful support for all parties involved.

              <span className='lowertext curser-pointer' onClick={handleToggle}>{isTextVisible ? "less" : ""}</span>

            </p>
          </div>
        }
      </section>

      <section className=" button-section p-4">
        <div className="left-col">
          <img src={imageFour} alt="" width={250} id='paritta' onClick={handleClick} />
          <img src={imageFive} alt="" width={250} id='danaathome' onClick={handleClick} />

        </div>
        <div className="right-col">
          <img src={imageSix} alt="" width={250} id='dhammasermons' onClick={handleClick} />
          <img src={imageSeven} alt="" width={250} id='funeralrituals' onClick={handleClick} />
        </div>
      </section>

      <div className="box">
        <img src={imageNine} alt="" className="bottom-imge" />
      </div>
    </div>
  )
}

export default Community;